import { MessageCircle } from "lucide-react";

import { SessionAnalysis } from "../../../../../types/supabase";
import BarGraph from "./BarChart";

interface ConvDynamicsProps {
  analysis: SessionAnalysis;
}

const color = "green";

export const ConvDynamics = ({ analysis }: ConvDynamicsProps) => {
  const wordCounts = analysis?.content?.word_counts || {
    total: 0,
    mentor: 0,
    mentee: 0,
  };
  const talkTimeRatioMentor =
    wordCounts && wordCounts.total > 0
      ? wordCounts.mentor / wordCounts.total
      : 0;
  const talkTimeRatioMentee =
    wordCounts && wordCounts.total > 0
      ? wordCounts.mentee / wordCounts.total
      : 0;

  return (
    <div className="rounded-xl bg-white p-6 shadow-sm">
      <h2 className="mb-6 flex items-center text-xl font-semibold">
        <MessageCircle className={`text- mr-2 size-5${color}-600`} />
        Conversation Dynamics
      </h2>
      <div className="grid">
        <div className="rounded-lg bg-gray-50 p-4">
          <h3 className="mb-2 font-medium text-gray-900">
            Talk Time Distribution
          </h3>
          {analysis?.content?.stressors &&
          talkTimeRatioMentor >= 0 &&
          talkTimeRatioMentee >= 0 ? (
            <BarGraph
              data={[
                {
                  label: "Mentor",
                  number: talkTimeRatioMentor,
                  fill: "indigo",
                },
                { label: "Mentee", number: talkTimeRatioMentee, fill: "green" },
              ]}
            />
          ) : (
            <div className="flex h-full flex-col items-center justify-center">
              <p className="mb-6 text-gray-600">Loading...</p>
            </div>
          )}
        </div>
        <div className="rounded-lg bg-gray-50 p-4">
          <h3 className="mb-2 font-medium text-gray-900">Word Count</h3>
          <div className="space-y-2">
            {wordCounts.mentor !== undefined &&
            wordCounts.mentee !== undefined ? (
              <>
                <div>Mentor: {wordCounts.mentor} words</div>
                <div>Mentee: {wordCounts.mentee} words</div>
              </>
            ) : (
              <div className="flex h-full flex-col items-center justify-center">
                <p className="mb-6 text-gray-600">Loading...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConvDynamics;
